import { inject } from '@angular/core';
import { FormControlDirective, FormControlName, NgControl, NgModel } from '@angular/forms';

/**
 * Used to get formControl from input
 * To be used along NoopValueAccessorDirective as host directive
 * https://netbasal.com/forwarding-form-controls-to-custom-control-components-in-angular-701e8406cc55
 */
export function injectNgControl() {
  const ngControl = inject(NgControl, { self: true, optional: true });

  if (!ngControl) {
    throw new Error('Please provide form control when calling this component');
  }

  if (
    ngControl instanceof FormControlDirective ||
    ngControl instanceof FormControlName ||
    ngControl instanceof NgModel
  ) {
    return ngControl;
  }

  throw new Error('Please provide form control when calling this component');
}
